import { cn } from '~utils/cn'

import Button, { ButtonProps } from '~components/ui/button'

/**
 * @version v1.1.2
 * @author Danny
 * @description priority 속성 되살림
 */

const DialogButton = ({ type, className, priority, disabled, children, onClick }: ButtonProps) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      priority={priority}
      className={cn('w-full lg:w-fit', className)}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}

export default DialogButton
